import { Form, Input, Modal, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

interface ModalEditarEmailProps {
  open: boolean;
  usuarioId: number;
  email: string;
  onCancel: () => void;
}

export default function ModalEditarEmail({
  open,
  usuarioId,
  email,
  onCancel,
}: ModalEditarEmailProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (open) form.setFieldsValue({ email });
  }, [open, email, form]);

  const atualizar = async ({ email: novoEmail }: { email: string }) => {
    const token = validateToken();
    if (!token) {
      document.location.href = "/";
      return;
    }

    setLoading(true);
    try {
      await axios.put(
        `${Globais.DOMINIOBACK}/usuario/${usuarioId}`,
        { email: novoEmail.trim() },
        { headers: { Authorization: token.AuthStr } }
      );
      messageApi.success("E-mail alterado com sucesso!");
      onCancel();
      setTimeout(() => document.location.reload(), 1000);
    } catch {
      messageApi.error("Não foi possível alterar o e-mail.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title="Editar e-mail"
        okText="Salvar"
        cancelText="Cancelar"
        confirmLoading={loading}
        onCancel={onCancel}
        onOk={() => form.validateFields().then(atualizar)}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="email"
            label="E-mail"
            rules={[{ required: true, message: "Informe o e-mail." }, { type: "email", message: "Informe um e-mail válido." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
